import script from "./productDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./productDetails.vue?vue&type=script&setup=true&lang=js"

import "./productDetails.css?vue&type=style&index=0&id=2295078f&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2295078f"]])

export default __exports__